import { mapGetters } from "vuex";
import { buildUpgradeNotice } from "@/utils/upgradeNotice";
import "@/theme/modal/UpgradeNotice.scss";

// กดฟีเจอร์ที่ล็อกไว้ (ป้าย "อัปเกรด") แล้วอธิบายว่าทำไมใช้ไม่ได้
//
// เปิดหน้าแพ็กในแท็บใหม่ ไม่ใช่ router.push — จุดที่ล็อกเกือบทั้งหมดอยู่ใน modal
// ประวัติคนไข้ ถ้าเปลี่ยนหน้าในแท็บเดิม modal ค้างอยู่และงานที่ทำค้างไว้หายไปด้วย
export default {
  computed: {
    ...mapGetters({
      isAccessMenuForUpgrade: "moduleUser/getIsAccessMenu",
    }),
  },
  methods: {
    // เนื้อหา popup — ไอคอนล็อกสีเดียวกับป้าย "อัปเกรด", หัวเรื่อง, ชื่อฟีเจอร์ + เหตุผล, ขั้นต่อไป
    upgradeNoticeContent(notice) {
      const h = this.$createElement;
      return h("div", { class: "upgrade-notice" }, [
        h("div", { class: "upgrade-notice-icon", attrs: { "aria-hidden": "true" } }, [
          h("i", { class: "fas fa-lock" }),
        ]),
        h("h2", { class: "upgrade-notice-title" }, notice.title),
        h("p", { class: "upgrade-notice-text" }, [
          h("strong", notice.featureName),
          ` ${notice.reason}`,
        ]),
        h("p", { class: "upgrade-notice-hint" }, notice.hint),
      ]);
    },
    async showUpgradeNotice(featureName) {
      const notice = buildUpgradeNotice({
        featureName,
        canOpenBilling: this.isAccessMenuForUpgrade(["MANAGER", "HEADCOUNTER"]),
      });
      const options = {
        size: "sm",
        centered: true,
        modalClass: "upgrade-notice-modal",
        footerClass: "upgrade-notice-footer",
        buttonSize: "md",
      };

      if (!notice.showBillingLink) {
        await this.$bvModal.msgBoxOk(this.upgradeNoticeContent(notice), {
          ...options,
          okTitle: "เข้าใจแล้ว",
          okVariant: "light",
        });
        return;
      }

      const confirmed = await this.$bvModal.msgBoxConfirm(this.upgradeNoticeContent(notice), {
        ...options,
        cancelTitle: "ปิด",
        cancelVariant: "light",
        // เปิดแท็บใหม่ — ไอคอนบอกให้รู้ก่อนกด
        okTitle: [
          "ดูแพ็ก ",
          this.$createElement("i", {
            class: "fas fa-external-link-alt ml-1",
            attrs: { "aria-hidden": "true" },
          }),
        ],
        okVariant: "primary",
      });
      if (!confirmed) return;

      const { clinicUrl, branchUrl } = this.$route.params;
      const { href } = this.$router.resolve({
        name: "BillingPlans",
        params: { clinicUrl, branchUrl },
      });
      window.open(href, "_blank", "noopener");
    },
  },
};
